module.exports = __webpack_public_path__ + "static/media/matzore_logo_192.f21953ff.png";